export const zhHK = {
  agree: '我/我們同意將我/我們的個人資料用於',
  directMarketing: '直銷推廣用途',
  period: '，以接收最新的優惠、 推廣活動、新產品資料或資訊等。',
  yes: '是',
  no: '否',
}
